import type { CSSObject } from "styled-components";

export const applyOnMaxWidth = (maxWidth: number, styles: CSSObject): CSSObject => ({
  [`@media (max-width: ${maxWidth}px)`]: styles,
});

export const hideOnMaxWidth = (maxWidth: number) => applyOnMaxWidth(maxWidth, { display: "none" });
